import { getAllAddons, getOrgAddons } from 'redux/addons/saga/fetchAddons';
import { onUpdateAddon } from 'redux/addons/saga/updateAddon';
import { call, all } from 'redux-saga/effects';

export default function* addonsSaga() {
  yield all([
    call(getAllAddons),
    call(getOrgAddons),
    call(onUpdateAddon)
  ]);
}
